/**
 * Fullscreendialog to block user from accessing the page due to maintenance
 *
 * File: \src\components\login\MaintenanceDialog.ts
 * Created Date: Thursday, December 17th 2020, 15:09:01
 * Author: Burhan Balkir
 * -----
 * Last Modified: July 24th 2024, 11:35:33
 * Modified By: Boryana Kircheva (HAU-ED)
 * -----
 * Copyright (c) 2017-2020 Liebherr-Hausgeräte GmbH
 */
import { defineComponent, computed, PropType } from 'vue';
import AssetHelper from '@/components/general/assets/AssetHelper';
import { useI18nStore } from '@/I18nStore';

export default defineComponent({
  props: {
    /**Controls dialog visibility */
    dialogShown: { type: Boolean, default: false },

    /**Data from blobstorage */
    data: { type: Object as PropType<any>, default: undefined }
  },
  setup(props) {
    const i18nStore = useI18nStore();

    /**Title for maintenance screen */
    const maintenanceTitle = computed(() => {
      if (props.data) {
        if (i18nStore.getLoadedLanguageLanguage === 'de') {
          return props.data.titleDe;
        } else {
          return props.data.titleEn;
        }
      } else {
        return '';
      }
    });

    /**Message for maintenance screen */
    const maintenanceMessage = computed(() => {
      if (props.data) {
        if (i18nStore.getLoadedLanguageLanguage === 'de') {
          return props.data.messageDe;
        } else {
          return props.data.messageEn;
        }
      } else {
        return '';
      }
    });

    return {
      AssetHelper,
      maintenanceTitle,
      maintenanceMessage
    };
  }
});
